<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-12-06 20:12:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/detail/components/HeaderDet/index.vue
-->
<template>
  <!-- 订单详情头部信息 -->
  <div class="header_con">
    <div class="top_1">
      <img
        :src="orderStatus(getUserOrder.status).img"
        alt=""
        class="top_time"
      />
      <span class="font18 font_weight600 colof top_title line_height_25">{{
        orderStatus(getUserOrder.status).name
      }}</span>
    </div>
    <div
      v-if="getUserOrder.status !== 10"
      class="font12 font_weight400 colof line_height_17 top_total"
    >
      {{ getUserOrder.orderConstant }}
    </div>
    <div
      v-if="getUserOrder.status === 10"
      class="font12 font_weight400 colof line_height_17 ma_top"
    >
      需付款：{{ getUserOrder.total | currency(false) }}
    </div>
    <!-- remainingTime -->
    <div
      v-if="getUserOrder.remainingTime && getUserOrder.status === 10"
      class="font12 font_weight400 colof line_height_17"
    >
      <van-count-down :time="getUserOrder.remainingTime">
        <template v-slot="timeData">
          <div class="font12 font_weight400 colof line_height_17">
            剩余：
            <span>{{ timeData.minutes || "00" }}分</span
            ><span>{{ timeData.seconds }}</span
            >秒，超出时间系统将自动取消订单
          </div>
        </template>
      </van-count-down>
      <!-- 剩余：01小时22分23秒，超出时间系统将自动取消订单 -->
    </div>
    <div
      v-if="getUserOrder.status === 10"
      class="go_pay font14 font_weight500 line_height_34"
      @click="clickBtn"
    >
      去支付
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    }
  },
  methods: {
    orderStatus(status) {
      switch (status) {
        case 10:
          return {
            img: require("@/assets/order/icon_time2x.png"),
            name: "待付款"
          };
        case 11:
          return {
            img: require("@/assets/order/icon_time2x.png"),
            name: "待发货"
          };
        case 12:
          return {
            img: require("@/assets/order/icon_time2x.png"),
            name: "待收货"
          };
        case 13:
        case 14:
          return {
            img: require("@/assets/order/icon_time2x.png"),
            name: "已完成"
          };
        case -10:
        case -11:
          return {
            img: require("@/assets/order/icon_wait@2x.png"),
            name: "已关闭"
          };
      }
    },
    clickBtn() {
      this.$emit("clickBtn", "去付款", this.getUserOrder.orderSn);
    }
  }
};
</script>

<style lang="less" scoped>
.header_con {
  .top_1 {
    font-size: 0;
    .top_time {
      width: 24px;
      vertical-align: middle;
    }
    .top_title {
      vertical-align: middle;
      margin-left: 1px;
    }
  }

  .top_total {
    margin: 5px 0;
  }
  .ma_top {
    margin: 4px 0;
  }
  .go_pay {
    background: #fff;
    box-shadow: 2px 3px 4px 0px rgba(180, 124, 67, 0.5),
      0px -2px 2px 0px rgba(191, 146, 100, 0.5);
    border-radius: 17px;
    width: 110px;
    color: #bf9264;
    margin: 16px auto 0;
  }
}
</style>
